import ReactSelect, { GroupBase } from 'react-select';
import { ClassNamesConfig } from 'react-select/dist/declarations/src/styles';

import './Select.scss';

type Option = {
  value: string;
  label: string;
};

interface NewSelectProps<T extends Option> {
  options: T[];
  onChange?: (option: T | null) => void;
  className?: string;
}

export default function Select<T extends Option>({ options, onChange, className = '' }: NewSelectProps<T>) {
  const classNames: ClassNamesConfig<T, false, GroupBase<T>> = {
    control: () => 'control',
    valueContainer: () => 'value-container',
    menu: () => 'menu',
    option: () => 'option',
  };

  return (
    <ReactSelect
      className={`new-select ${className}`}
      isSearchable={false}
      onChange={onChange}
      options={options}
      classNames={classNames}
      unstyled
    />
  );
}
